import apiActionTypes from '../../../redux/actions/types';
import { validateCompaniesCorpo } from '../../../scripts/utilities/corporate-helpers';
import CompaniesCorporateCollectionUIModel from '../../../api-wrapper/ui-models/companies-corporate-collection';

const initialState = {
  changeCorporateCompany : false,
  changeCorporateFlow : false,
  changeSwitchFlowCorporate: false,
  corporateSupplierSelected: 'personal',
  isActiveFlowCorporate: false,
  isLoadingCorporate: false,
  isRetrieveCorporateSession: false,
  loginCorporate : false,
  showModalCorporate: false,
  userCorporate: {
    companies: new CompaniesCorporateCollectionUIModel(),
    isValidUser: false,
    companySelected: '',
  },
};

const actionsMap = {
  [apiActionTypes.SET_DATA_CORPORATE.START]: (state, action) => {
    const data = action?.payload?.data;
    const companies = data?.companies;
    const existCorporate = data?.existInNutravel;
    const existCompanies = validateCompaniesCorpo(companies);
    const isCompaniesCorporate = existCorporate && !existCompanies;
    let companiesCorporate = new CompaniesCorporateCollectionUIModel();
    let isValidUser = false;
    let showModalCorporate = false;

    if (isCompaniesCorporate) {
      companiesCorporate = new CompaniesCorporateCollectionUIModel({ companies });
      isValidUser = true;
      showModalCorporate = true;
    }

    return {
      ...state,
      userCorporate: {
        ...state.userCorporate,
        companies: companiesCorporate,
        isValidUser,
      },
      showModalCorporate: showModalCorporate,
    };
  },
  [apiActionTypes.SET_DATA_CORPORATE_RETRIEVE_PROFILE.START]: (state, action) => {
    const data = action?.payload?.data;
    const companies = data?.companies;
    const existCorporate = data?.existInNutravel;
    const existCompanies = validateCompaniesCorpo(companies);
    const corporateExist = existCorporate && !existCompanies;
    let companiesCorporate = new CompaniesCorporateCollectionUIModel();
    let isValidUser = false;
    if (corporateExist) {
      companiesCorporate = new CompaniesCorporateCollectionUIModel({ companies });
      isValidUser = true;
    }
    return {
      ...state,
      userCorporate: {
        ...state.userCorporate,
        companies: companiesCorporate,
        isValidUser,
      },
      showModalCorporate: false,
    };
  },
  [apiActionTypes.SET_FLOW_CORPORATE.START]: (state, action) => ({
    ...state,
    isActiveFlowCorporate: action.payload,
  }),
  [apiActionTypes.SET_NAME_COMPANY.START]: (state, action) => {
    state.userCorporate.companies.setCompanySelected(action.payload);
    return {
      ...state,
      userCorporate: {
        ...state.userCorporate,
        companySelected: action.payload,
      },
    };
  },
  [apiActionTypes.SET_CORPORATE_SUPPLIER_SELECTED]: (state, action) => ({
    ...state,
    corporateSupplierSelected: action.supplier,
  }),
  [apiActionTypes.CLOSE_MODAL_CORPORATE.START]: (state) => ({
    ...state,
    showModalCorporate: false,
  }),
  [apiActionTypes.OPEN_MODAL_CORPORATE.START]: (state) => ({
    ...state,
    showModalCorporate: true,
  }),
  [apiActionTypes.CHANGE_CORPORATE_FLOW.START]: (state, action) => ({
    ...state,
    changeCorporateFlow: action.payload,
  }),
  [apiActionTypes.CHANGE_SWITCH_FLOW.START]: (state, action) => ({
    ...state,
    changeSwitchFlowCorporate: action.payload,
  }),

  [apiActionTypes.CHANGE_CORPORATE_COMPANY.START]: (state, action) => ({
    ...state,
    changeCorporateCompany: action.payload,
  }),

  [apiActionTypes.LOGIN_CORPORATE.START]: (state, action) => ({
    ...state,
    loginCorporate: action.payload,
  }),
  [apiActionTypes.RETRIEVE_CORPORATE_PROFILE_DATA.START]: (state, action) => ({
    ...state,
    isRetrieveCorporateSession: action.payload,
  }),
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  if (!fn) {
    return state;
  }
  return fn(state, action);
}